import { render, staticRenderFns } from "./BalanceTable.vue?vue&type=template&id=aaab9caa&scoped=true&"
import script from "./BalanceTable.vue?vue&type=script&lang=ts&"
export * from "./BalanceTable.vue?vue&type=script&lang=ts&"
import style0 from "./BalanceTable.vue?vue&type=style&index=0&id=aaab9caa&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaab9caa",
  null
  
)

export default component.exports